 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT01_COVER from '@/components/Text/01_cover'
 import TEXT02_TITLEPAGE from '@/components/Text/02_titlepage'
 import TEXT03_COPYRIGHT_PAGE from '@/components/Text/03_Copyright_page'
 import TEXT04_DEDICATION from '@/components/Text/04_Dedication'
 import TEXT05_CONTENTS from '@/components/Text/05_Contents'
 import TEXT06_ACKNOWLEDGEMENTS from '@/components/Text/06_Acknowledgements'
 import TEXT07_INTRODUCTION from '@/components/Text/07_Introduction'
 import TEXT08_CHAPTER_01 from '@/components/Text/08_Chapter_01'
 import TEXT09_CHAPTER_02 from '@/components/Text/09_Chapter_02'
 import TEXT10_CHAPTER_03 from '@/components/Text/10_Chapter_03'
 import TEXT11_CHAPTER_04 from '@/components/Text/11_Chapter_04'
 import TEXT12_CHAPTER_05 from '@/components/Text/12_Chapter_05'
 import TEXT13_CHAPTER_06 from '@/components/Text/13_Chapter_06'
 import TEXT14_CHAPTER_07 from '@/components/Text/14_Chapter_07'
 import TEXT15_CHAPTER_08 from '@/components/Text/15_Chapter_08'
 import TEXT16_CHAPTER_09 from '@/components/Text/16_Chapter_09'
 import TEXT17_CHAPTER_10 from '@/components/Text/17_Chapter_10'
 import TEXT18_CHAPTER_11 from '@/components/Text/18_Chapter_11'
 import TEXT19_EPILOGUE from '@/components/Text/19_Epilogue'
 import TEXT20_NOTES from '@/components/Text/20_Notes'
 import TEXT21_BIBLIOGRAPHY from '@/components/Text/21_Bibliography'
 import TEXT22_INDEX from '@/components/Text/22_Index'
 import TEXT23_ABOUT_AUTHOR from '@/components/Text/23_About_author'
 import TEXT24_OTHER_PRESS from '@/components/Text/24_Other_press'
 import TEXTEXT_DESC_FIG21 from '@/components/Text/Ext_desc_fig2.1'
 import TEXTEXT_DESC_FIG31 from '@/components/Text/Ext_desc_fig3.1'
 import TEXTEXT_DESC_FIG51 from '@/components/Text/Ext_desc_fig5.1'
 import TEXTEXT_DESC_FIG71 from '@/components/Text/Ext_desc_fig7.1'
 import TEXTEXT_DESC_FIG81 from '@/components/Text/Ext_desc_fig8.1'
 import TEXTEXT_DESC_FIG82 from '@/components/Text/Ext_desc_fig8.2'
 import TEXTEXT_DESC_FIG83 from '@/components/Text/Ext_desc_fig8.3'
 import TEXTEXT_DESC_FIG91 from '@/components/Text/Ext_desc_fig9.1'
 import TEXTEXT_DESC_FIG101 from '@/components/Text/Ext_desc_fig10.1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/05_Contents",
 			"name" : "Text/05_Contents",
 			"component" : TEXT05_CONTENTS
 		},
 		{
 			"path" : "/Text/06_Acknowledgements",
 			"name" : "Text/06_Acknowledgements",
 			"component" : TEXT06_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/Text/07_Introduction",
 			"name" : "Text/07_Introduction",
 			"component" : TEXT07_INTRODUCTION
 		},
 		{
 			"path" : "/Text/08_Chapter_01",
 			"name" : "Text/08_Chapter_01",
 			"component" : TEXT08_CHAPTER_01
 		},
 		{
 			"path" : "/Text/09_Chapter_02",
 			"name" : "Text/09_Chapter_02",
 			"component" : TEXT09_CHAPTER_02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js